<template>
  <modal v-bind="[$props, $attrs]"
         :close-button-visible="false"
         @modal-close="emitCloseEvent"
         size="md">
    <transition name="fade" mode="out-in">
      <base-inline-loader v-if="$props.loading"
                          height="365"/>
      <div v-else
           class="benefit-activation-modal">
        <h3 class="common-title">{{ $t('benefits.activationModal.title') }}</h3>
        <p v-if="$props.benefitType === 'TOP_UP'" class="common-subtitle" v-html="$t('benefits.activationModal.descriptionAlt', { name: $props.benefitName })"></p>
        <p v-else class="common-subtitle" v-html="$t('benefits.activationModal.description', { name: $props.benefitName })"></p>
        <validation-observer ref="benefitsObs"
                             tag="form"
                             class="benefits-form"
                             @submit.prevent="submitBenefitRequest">
          <base-v-input v-if="$props.benefitType === 'TOP_UP'"
                        v-model="phoneNumber"
                        id="phoneNumber"
                        name="phoneNumber"
                        :submitted="benefitsFormSubmitted"
                        :label="$t('benefits.activationModal.phoneLabel')"
                        :placeholder="$t('benefits.activationModal.phonePlaceholder')"
                        rules="required|phoneNumberWithSpaces|max:15"
                        vid="phoneNumber"
                        maxlength="15"/>
          <div v-else
               class="custom-dropdown light-label">
            <label class="label">{{ $t('benefits.activationModal.contractLabel') }}</label>
            <v-select class="select-dropdown dark-background"
                      required
                      v-model="selectedCustomerId"
                      :options="userList"
                      :reduce="option => option.subscriberIdentity"
                      :filterable="false"
                      :searchable="false"
                      label="_selectLabel">
              <span slot="no-options">{{ $t('common.noData') }}</span>
            </v-select>
          </div>
          <div class="benefit-actions">
            <base-button variant="primary"
                         :disabled="isSubmitDisabled"
                         type="submit">
              {{ $props.benefitType === 'TOP_UP' ? $t('common.pay_alt') : $t('common.activate') }}
            </base-button>
            <base-button variant="text"
                         class="cancel-button"
                         @click="emitCloseEvent">
              {{ $t('common.cancel') }}
            </base-button>
          </div>
        </validation-observer>
      </div>
    </transition>
  </modal>
</template>

<script>
import Modal from '@/components/common/modal/modal'

export default {
  name: 'activate-benefit-modal',
  inheritAttrs: false,
  components: { Modal },
  data () {
    return {
      selectedCustomerId: '',
      phoneNumber: '',
      benefitsFormSubmitted: false
    }
  },
  props: {
    benefitName: {
      type: String,
      default: ''
    },
    benefitType: {
      type: String,
      default: 'common'
    },
    tvServices: {
      type: Array,
      default: () => []
    },
    mobileServices: {
      type: Array,
      default: () => []
    },
    loading: Boolean
  },
  computed: {
    userList () {
      if (this.$props.benefitType === 'TV_ADDON') {
        return this.$props.tvServices.map(service => {
          service._selectLabel = `${service.title} - ${service.description}`
          return service
        })
      }
      return this.$props.mobileServices.map(service => {
        service._selectLabel = `${service.title} - ${service.description}`
        return service
      })
    },
    isSubmitDisabled () {
      if (this.$props.benefitType === 'TOP_UP') {
        return !this.phoneNumber
      }
      return !this.selectedCustomerId
    }
  },
  methods: {
    emitCloseEvent () {
      this.benefitsFormSubmitted = false
      this.$emit('close')
    },
    async submitBenefitRequest () {
      this.benefitsFormSubmitted = true
      const isFormValid = await this.$refs.benefitsObs.validate()
      if (isFormValid) {
        if (this.$props.benefitType === 'TOP_UP') {
          this.$emit('submit-topup-benefit', this.phoneNumber)
        } else {
          this.$emit('submit-common-benefit', this.selectedCustomerId)
        }
      }
    }
  },
  watch: {
    userList (newVal) {
      if (newVal && newVal.length) {
        this.$nextTick(() => {
          this.selectedCustomerId = this.userList.length ? this.userList[0].subscriberIdentity : ''
        })
      } else {
        this.selectedCustomerId = ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
.benefit-activation-modal {
  padding-top: 2.8rem;
  text-align: center;

  .benefits-form {
    max-width: 400px;
    margin: auto;
    text-align: left;

    .validated-input {
      padding-bottom: 0;
    }
  }
}

.common-subtitle {
  max-width: 450px;
  margin-left: auto;
  margin-right: auto;
}

.benefit-actions {
  text-align: center;
  padding: 4rem 0 2.8rem;

  .variant-primary {
    margin-bottom: 1.5rem;
    width: 100%;

    @media (map_get($breakpoints, exsm)) {
      margin-bottom: 0;
      width: auto;
    }
  }

  .cancel-button {
    @media (map_get($breakpoints, exsm)) {
      margin-left: 4rem;
    }
  }
}
</style>
